import { render, staticRenderFns } from "./DialogGroupsAddEditFolder.vue?vue&type=template&id=e0b91586"
import script from "./DialogGroupsAddEditFolder.vue?vue&type=script&lang=js"
export * from "./DialogGroupsAddEditFolder.vue?vue&type=script&lang=js"
import style0 from "./DialogGroupsAddEditFolder.vue?vue&type=style&index=0&id=e0b91586&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports